
export function getFeatureByIndex(mainTabIndex, featureIndex, featureInfoIndex) {


    if(featureInfoIndex === null) {
        return window.mainTabs[mainTabIndex].features[featureIndex].feature
    }

    return window.mainTabs[mainTabIndex].features[featureIndex].featureInfo[featureInfoIndex].records[0]
}
